/* unplugin-vue-components disabled */import script from "./FeedbackInfoView.vue?vue&type=script&lang=tsx&setup=true"
export * from "./FeedbackInfoView.vue?vue&type=script&lang=tsx&setup=true"

import "./FeedbackInfoView.vue?vue&type=style&index=0&id=5063a1b4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5063a1b4"]])

export default __exports__